import { render, staticRenderFns } from "./NotificationsPaymentList.vue?vue&type=template&id=5f841de0&"
import script from "./NotificationsPaymentList.vue?vue&type=script&lang=js&"
export * from "./NotificationsPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports